<template>
  <div v-if="iframeUrl">
    <iframe
      :src="iframeUrl"
      width="100%"
      height="1024px"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script setup>
import { ref, onMounted, inject } from 'vue'
import WhalyUrlsService from '@/services/whalyUrls'
import { WHALY_LINK } from '@/constants'

const props = defineProps({
  page: {
    type: String,
    required: true,
  }
});

const iframeUrl = ref(null)
const missionPlanning = inject("missionPlanning")
const currentConfiguration = inject("currentConfiguration")
const currentPointOfSale = inject("currentPointOfSale")

onMounted(async () => {
  let recordId;
  try {
    switch (props.page) {
      case WHALY_LINK.POINTS_OF_SALE:
        recordId = missionPlanning.value?.mission?.id;
        break;
      case WHALY_LINK.SECTORS:
        recordId = `${currentConfiguration.value?.id}-${currentPointOfSale.value?.area?.id}`;
        break;
      default:
        throw new Error("Invalid page type for WhalyPageView: " + props.page);
    }
    const response = await WhalyUrlsService.getLink({page:props.page, recordId: recordId})
    iframeUrl.value = response.data.url
  } catch (error) {
    console.error('Error fetching embed URL:', error)
  }
})
</script>